// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ITTObjectModel from '../../model/itt-object-model';
import ITTObjectDTO from '../dto/itt-object-dto';
import dtoSchema from '../schemas/itt-object-schema';

export default abstract class ITTObjectModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ITTObjectDTO>) {
    super();
    if (data) {
      this.comment = data.comment ?? undefined;
      this.ttComment = data.ttComment ?? undefined;
      this.isTT = data.isTT;
    }
  }
  /**
  */
  comment?: string;
  /**
  */
  ttComment?: string;
  /**
  */
  isTT?: boolean;

  static toModel(dto: DeepPartial<ITTObjectDTO>): ITTObjectModel;
  static toModel(dto: DeepPartial<ITTObjectDTO> | undefined | null): ITTObjectModel | undefined;
  static toModel(dto: DeepPartial<ITTObjectDTO> | undefined | null): ITTObjectModel | undefined {
    return dto ? new ITTObjectModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ITTObjectModel> | ITTObjectModel): ITTObjectDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      comment: unwrapped.comment,
      ttComment: unwrapped.ttComment,
      isTT: unwrapped.isTT,
    } as ITTObjectDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for ITTObjectModel, can not map to ITTObjectDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
